import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useConfigStyles = makeStyles((theme: Theme) => ({
  container: {
    backgroundColor: theme.palette.background.paper,
    padding: 10,
  },
  table: {
    minWidth: 650,
    marginTop: 10,
    '& .MuiTableCell-body': {
      fontSize: 15,
      fontFamily: '"Tahoma",Geneva,Arial,sans-serif',
    },
    '& .MuiTableCell-head': {
      fontSize: 16,
      fontFamily: 'Tahoma,Geneva,Arial,sans-serif',
      fontWeight: 800,
    },
  },
  tableHeader: {
    backgroundColor: theme.palette.grey[400],
    fontWeight: 'bold',
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  tableContainer: {
    width: 600,
    maxHeight: 768,
    alignContent: 'center',
    backgroundColor: theme.palette.background.paper,
  },
  form: {
    margin: 'auto',
    height: 'auto',
  },
  paper: {
    width: 'auto',
    maxHeight: 768,
    alignContent: 'center',
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    margin: theme.spacing(1, 0),
  },
  filterInput: {
    margin: theme.spacing(1, 1),
    height: 40,
  },
  button: {
    margin: theme.spacing(2, 1),
  },
  breadcrumbs: {
    margin: theme.spacing(4, 1),
  },
  root: {
    margin: 'auto',
    flexGrow: 1,
  },
  tabs: {
    margin: 15,
    width: 'auto',
  },
  error: {
    color: theme.palette.error.light,
  },
}));

export default useConfigStyles;
